import { CATEGORY_SET, CATEGORY_CLEAR } from './types';

export const setCategoriesAction = categories => ({
  type: CATEGORY_SET,
  categories,
});
export const clearCategoriesAction = () => ({ type: CATEGORY_CLEAR });
